"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AuthService = void 0;
var axios_1 = __importDefault(require("axios"));
var lodash_1 = require("lodash");
var AuthService = (function () {
    function AuthService() {
        var _this = this;
        this.api = process.env.AUTH_API;
        this.apiKey = process.env.EDULAR_API_KEY;
        this.getMe = function (token) { return __awaiter(_this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        console.log(this.api + "/v2/get-me");
                        return [4, axios_1.default.get(this.api + "/v2/get-me", {
                                headers: {
                                    authorization: token
                                }
                            })];
                    case 1:
                        response = _a.sent();
                        return [2, response.data];
                }
            });
        }); };
        this.getToken = function (slug) { return __awaiter(_this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, axios_1.default.post(this.api + "/v2/get-token", {
                            slug: slug,
                            apiKey: this.apiKey
                        })];
                    case 1:
                        response = _a.sent();
                        return [2, response.data];
                }
            });
        }); };
    }
    AuthService.prototype.getColleges = function (data) {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            var response, e_1, error;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 2, , 3]);
                        return [4, axios_1.default.post(this.api + "/v2/get-colleges", {
                                slug: (data === null || data === void 0 ? void 0 : data.slug) || undefined,
                                apiKey: this.apiKey
                            })];
                    case 1:
                        response = (_b.sent()).data;
                        if (!response.success || response.data.length === 0) {
                            throw new Error("College not found");
                        }
                        return [2, response.data];
                    case 2:
                        e_1 = _b.sent();
                        error = e_1;
                        console.error("Error getting colleges");
                        throw ((_a = error === null || error === void 0 ? void 0 : error.response) === null || _a === void 0 ? void 0 : _a.data) || e_1;
                    case 3: return [2];
                }
            });
        });
    };
    AuthService.prototype.getInsecureToken = function (data) {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            var response, e_2, error;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 2, , 3]);
                        return [4, axios_1.default.post(this.api + "/v2/get-insecure-user-token", {
                                slug: data.slug,
                                userId: data.userId,
                                apiKey: this.apiKey
                            })];
                    case 1:
                        response = (_b.sent()).data;
                        if (!response.success) {
                            throw new Error("Error getting insecure token");
                        }
                        return [2, response.data];
                    case 2:
                        e_2 = _b.sent();
                        error = e_2;
                        console.error("Error getting insecure token");
                        throw ((_a = error === null || error === void 0 ? void 0 : error.response) === null || _a === void 0 ? void 0 : _a.data) || e_2;
                    case 3: return [2];
                }
            });
        });
    };
    AuthService.prototype.signIn = function (data) {
        return __awaiter(this, void 0, void 0, function () {
            var response, e_3, error;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4, axios_1.default.post(this.api + "/v2/normal-sign-in", data)];
                    case 1:
                        response = _a.sent();
                        return [2, (0, lodash_1.get)(response, "data.data", {})];
                    case 2:
                        e_3 = _a.sent();
                        error = e_3;
                        throw error.response.data;
                    case 3: return [2];
                }
            });
        });
    };
    AuthService.prototype.getinsecureTokenF = function () {
        return __awaiter(this, void 0, void 0, function () {
            var response, e_4, error;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4, axios_1.default.post(process.env.BASE_DOMAIN + "/" + "get-token", {})];
                    case 1:
                        response = _a.sent();
                        return [2, (0, lodash_1.get)(response, "data", {})];
                    case 2:
                        e_4 = _a.sent();
                        error = e_4;
                        throw error.response.data;
                    case 3: return [2];
                }
            });
        });
    };
    return AuthService;
}());
exports.AuthService = AuthService;
//# sourceMappingURL=data:application/json;base64,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